import {withBasicData} from 'core/next/controllers';
import {TAppInitialController} from 'core/redux/types';
import {TGsspData} from 'core/types';
import {breadCrumbsController} from 'modules/breadcrumbs/controller';
import {CategoryFirstLevelPageProvider} from 'modules/categories/providers/CategoryFirstLevelPageProvider';
import {NextPage} from 'next';

const CatalogPage: NextPage = () => {
    return <CategoryFirstLevelPageProvider />;
};

export const categoryPageController: TAppInitialController<TGsspData> = async (store, ctx) => {
    await Promise.allSettled([breadCrumbsController(store, ctx)]);

    return {
        props: {},
    };
};

CatalogPage.getInitialProps = withBasicData(categoryPageController);

export default CatalogPage;
